import http from '../const/http-common'

const getInitialData = (dbInfo) => {
  return http.post("/initialData", dbInfo);
};

const getTableData = (table) => {
  return http.post("/getTableData", {table: table});
};

const pivot = (pivotInfo) => {
  // console.log(JSON.stringify(pivotInfo));
  const config = {
    method: 'post',
    url: 'http://localhost:4000/pivot',
    headers: {
      'Content-Type': 'text/plain'
    },
    data: JSON.stringify(pivotInfo)
  };
  return http.request(config);
};

const SheetService = {
  pivot,
  getInitialData,
  getTableData
};

export default SheetService;